module.exports = __webpack_public_path__ + "static/media/parking-unavailable.18c1694d.svg";